import { ChevronRightRounded } from "@material-ui/icons";
import Parser from "../utils/parser";
import Button from "./Button";
import ListItem from "./ListItem";
import Text from "./Text";

export default function PriceBox({ config, mode = "LIGHT" }) {
  const mainPrice = config.prices[0];

  return (
    <div className={"price-box " + (config.mode || mode)} id="pricing" style={config.style || {}}>
      <Text
        config={{
          variant: "H4",
          color: "light",
          text: config.title,
        }}
      />

      {
        config.mode === 'MAIN' && <p className="main-plan-badge">Recomendado</p>
      }

      <span className="divider"></span>

      <img src={config.logo} className={"price-logo"} />

      {config.benefits?.map((item, index) => (
        <ListItem
          config={{
            title: item,
          }}
          key={"list-item-" + index}
        />
      ))}

      {mainPrice.fullPrice && (
        <Text
          config={{
            variant: "P",
            color: "light",
            text: `De R$${Parser.price.brl(
              mainPrice.fullPrice
            )} / ${Parser.interval.noun(mainPrice.interval)} por`,
            style: {
              width: "100%",
              marginTop: "30px",
              textDecoration: 'line-through',
              opacity: 0.6,
            },
          }}
        />
      )}

      <Text
        config={{
          variant: "H1",
          color: "light",
          text: `${mainPrice.installments ? '<span style="font-size: 16px; text-wrap: nowrap; color: white; font-weight: 200">' + mainPrice.installments + 'x</span>' : ''}R$${Parser.price.brl(mainPrice.price)}`,
          style: {
            width: "100%",
            marginTop: "0px",
            fontSize: "46px",
            lineHeight: "52px",
            fontWeight: 600
          },
        }}
      />

      {
        config.subprice && (
          <Text
            config={{
              variant: "H4",
              color: "light",
              text: config.subprice,
              style: {
                marginTop: "-10px",
                marginBottom: "10px",
              }
            }}
          />
        )
      }

      <Text
        config={{
          variant: "P",
          color: "light",
          text: `*Cobrança automática ${Parser.interval.adjective(
            mainPrice.interval
          )}`,
          style: {
            width: "100%",
            marginTop: "0px",
            opacity: 0.4,
          },
        }}
      />

      <Button
        config={{
          variant: "SECONDARY",
          text: config.cta.text,
          redirect: mainPrice.href,
          style: {
            width: "100%",
            marginTop: "30px",
          },
        }}
      />

      {config.prices.length > 1 && (
        <>
          <Text
            config={{
              variant: "H5",
              color: "light",
              text: "Outras assinaturas neste plano:",
              style: {
                width: "100%",
                textAlign: "left",
                marginTop: "40px",
              },
            }}
          />
          {config.prices
            .filter((_, i) => i !== 0)
            .map((price, index) => (
              <PriceRow info={price} key={index} />
            ))}
        </>
      )}
    </div>
  );
}

function PriceRow({ info }) {
  return (
    <a className="other-prices-row" href={info.href}>
      <Text
        config={{
          variant: "P",
          color: "light",
          text: `${Parser.interval.adjective(
            info.interval
          )}, R$${Parser.price.brl(info.price)} / ${Parser.interval.noun(
            info.interval
          )}`,
          style: {
            textAlign: "left",
            textWrap: "nowrap",
          },
        }}
      />

      <div className="other-prices-btn">
        <Text
          config={{
            variant: "P",
            color: "light",
            text: `Assinar`,
          }}
        />
        <ChevronRightRounded />
      </div>
    </a>
  );
}
